<template>
  <div class="modal fade" id="price-info-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-info-circle mr-5"></i>Hilfe</h4>
        </div>
        <div class="modal-body">
          <p>Der VK-Hinweis gibt Ihnen Auskunft über den eigentlich erwarteten Umsatz Ihrer bisherigen Verkäufe über schuhe.de. Der Wert berücksichtigt die Gesamtzahl aller bisherigen Bestellungen.</p>
          <p>Durch die Preisgestaltung von schuhe.de ergibt sich ein tatsächlicher Umsatz, der von dem erwarteten Umsatz abweichen kann. Die Differenz zeigt auf, wieviel Umsatz mehr oder weniger Sie durch den Verkauf über schuhe.de im Vergleich zu Ihren übermittelten VK-Preisen im gesamten Zeitraum erzielt haben.</p>
          <strong>Sollten Sie also einmal eine Bestellung erhalten, deren VK niedriger als der von Ihnen übermittelte ist - bedenken Sie bitte im Gegenzug, welchen Mehrumsatz Sie ggf. aufgrund unserer Preisgestaltung bereits erzielt haben.</strong>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
    methods: {
    },
    mounted () {
      this.$nextTick(() => {
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/PriceInfoModal.vue